import { type JSX } from 'solid-js'

export function CheckCutoutIcon(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0C2.68342 0 0 2.68342 0 6C0 9.31658 2.68342 12 6 12C9.31658 12 12 9.31658 12 6C12 2.68342 9.31658 0 6 0ZM9.26633 4.64322L5.56784 8.33166C5.42714 8.46231 5.25628 8.53266 5.07538 8.53266C4.89447 8.53266 4.72362 8.46231 4.58291 8.33166L2.73367 6.48241C2.46231 6.21106 2.46231 5.76884 2.73367 5.49749C3.00503 5.22613 3.44724 5.22613 3.71859 5.49749L5.07538 6.85427L8.28141 3.64824C8.55276 3.37688 8.99498 3.37688 9.26633 3.64824C9.53769 3.9196 9.53769 4.36181 9.26633 4.63317V4.64322Z"
        fill="white"
      />
    </svg>
  )
}
